import { useEffect, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import ButtonComp from '@components/UI/Button/Index';
import RenderIfStatusAndRole from '@components/UI/RenderIfStatusAndRole/Index';
import PlanoAcaoAnexoModal from '@components/Modals/User/PlanoAcaoAnexoModal/Index';
import PlanoAcaoViewerModal from '@components/Modals/Shared/PlanoAcaoViewerModal/Index';
import { carregarPlanosAcao } from '@store/slices/planosAcaoSlice';
import { perfisTodos, perfisUnidadeGerencia } from '@utils/auth/perfis';

export default function PlanoAcaoHandler({
  idSolicitacao,
  idProcesso,
  idUnidadeGerencia,
  codigoProcesso,
  flagAuditoria,
  planosAcaoExistentes = []
}) {
  const dispatch = useDispatch();

  // Estados separados para cada modal
  const [visibleAnexo, setVisibleAnexo] = useState(false);
  const [visibleViewer, setVisibleViewer] = useState(false);

  const key = `${idProcesso}-${idUnidadeGerencia}`;

  // 1) Sempre que a prop mudar, atualiza o slice
  useEffect(() => {
    dispatch(
      carregarPlanosAcao({
        key,
        planosAcao: planosAcaoExistentes
      })
    );
  }, [dispatch, key, planosAcaoExistentes]);

  // Ações para modal de anexo
  const openModalAnexo = () => setVisibleAnexo(true);
  const closeModalAnexo = () => setVisibleAnexo(false);

  // Ações para modal de visualização
  const openModalViewer = () => setVisibleViewer(true);
  const closeModalViewer = () => setVisibleViewer(false);

  return (
    <>
      {/* UNIDADE pode ANEXAR planos de ação na fase 4 */}
      <RenderIfStatusAndRole
        idSolicitacao={idSolicitacao}
        allowedStatuses={[5]}
        allowedRoles={perfisUnidadeGerencia}
        flagAuditoria={flagAuditoria}
        onlyIfAuditoria={true}
      >
        <ButtonComp
          title="ANEXAR PLANO DE AÇÃO"
          type="button"
          onClick={openModalAnexo}
          buttonColor="#125578"
          classnameIcon="fa-solid fa-paperclip"
          hoverMessage="Botão exclusivo para anexar planos de ação"
        />
        <PlanoAcaoAnexoModal
          visible={visibleAnexo}
          closeModal={closeModalAnexo}
          idSolicitacao={idSolicitacao}
          idProcesso={idProcesso}
          idUnidadeGerencia={idUnidadeGerencia}
          codigoProcesso={codigoProcesso}
          planosAcaoExistentes={planosAcaoExistentes}
        />
      </RenderIfStatusAndRole>

      {/* AUDITOR OU UNIDADE podem VISUALIZAR planos de ação nas fases 5 e 6 */}
      <RenderIfStatusAndRole
        idSolicitacao={idSolicitacao}
        allowedStatuses={[6, 7]}
        allowedRoles={perfisTodos}
        flagAuditoria={flagAuditoria}
        onlyIfAuditoria={true}
      >
        <ButtonComp
          title="VISUALIZAR PLANO DE AÇÃO"
          type="button"
          onClick={openModalViewer}
          buttonColor="#125578"
          classnameIcon="fa-solid fa-eye"
          hoverMessage="Visualizar um plano de ação anexado à solicitação"
        />
        <PlanoAcaoViewerModal
          visible={visibleViewer}
          closeModal={closeModalViewer}
          idProcesso={idProcesso}
          idUnidadeGerencia={idUnidadeGerencia}
        />
      </RenderIfStatusAndRole>
    </>
  );
}
